import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { animated, easings, useSpring } from '@react-spring/web';
import { useTranslations } from 'next-intl';
import { CorrectnessIndicator } from '../components/CorrectnessIndicator';
import { CORRECT_ANSWER_ANIMATION_DURATION } from './constants';

export const CorrectAnswerBox = ({
  correctAnswer,
  shouldShowCorrectAnswer,
  left,
  shouldShow,
  acceptedRange,
}: {
  correctAnswer: number;
  shouldShowCorrectAnswer: boolean;
  left: number;
  shouldShow: boolean;
  acceptedRange:
    | {
        min: number;
        max: number;
      }
    | undefined;
}) => {
  const t = useTranslations('presenting');

  const styles = useSpring({
    opacity: shouldShow ? 1 : 0,
    config: {
      duration: CORRECT_ANSWER_ANIMATION_DURATION,
      easing: easings.easeOutExpo,
    },
  });

  return (
    <animated.div style={{ opacity: styles.opacity }}>
      <Box
        position="absolute"
        top={0}
        left={left}
        bg="neutral"
        flexDirection="row"
        alignItems="center"
        borderRadius="2xl"
        p="space6"
        style={{
          transform: 'translate(-50%, 0)',
        }}
      >
        <CorrectnessIndicator
          shouldShow={shouldShowCorrectAnswer}
          isCorrect={true}
          immediate={false}
          size="40px"
          mr="space4"
        />
        <Text fontSize="200" lineHeight="100">
          {correctAnswer}
        </Text>

        {acceptedRange && (
          <Box ml="space8" alignItems="center" justifyContent="center">
            <Text fontSize="125" color="textWeaker">
              {t('guess_the_number_slide_accepted_range_label')}
            </Text>
            <Text fontSize="175" color="textWeaker">
              {acceptedRange.min}-{acceptedRange.max}
            </Text>
          </Box>
        )}
      </Box>
    </animated.div>
  );
};
